<template>
  <div class="field-radio-group" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <el-radio-group v-model="internalValue" v-validate="validate" :data-vv-as="validateLabel">
      <div v-for="option in options" class="field-radio-button" :class="{ 'inline': displayInline }">
        <el-radio :name="name" :label="option.value" style="font-size: 1rem;"
                  :disabled="readonly === true && option.value !== internalValue">{{option.label}}
        </el-radio>
      </div>
    </el-radio-group>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">

export default {
  name: 'FieldRadioGroupCmp',
  components: {},
  props: {
    value: null,
    name: '',
    validate: null,
    validateLabel: '',
    options: Array,
    displayInline: {type: Boolean, default: true},
    validateScope: null,
    readonly: {type: Boolean, default: false}
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('change', newValue)
    }
  }
}

</script>
<style scoped>
  .field-radio-group {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .field-radio-button.inline {
    display: inline;
  }

  .field-radio-button:not(.inline) {
    display: block;
  }

  .field-radio-button:not(.inline):not(:last-child) {
    padding-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/form/field/radio-group.vue